export const colorTypes = {
    none: { key: 1, title: 'None' },
    exact: { key: 2, title: 'Exact' },
    context: { key: 3, title: 'Context' },
    handle: { key: 4, title: 'Handle' }
};
